var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{class:{'clickable': _vm.onClick},attrs:{"src":_vm.icon,"alt":"icon","height":_vm.size,"width":_vm.size},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }